import * as z from "zod"

export const FrontContactModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  email: z.string(),
  name: z.string(),
  aliases: z.string().array(),
})
